<template>
    <div class="scroll-snap vh-100">
        <NavComp class="apply-snap-scroll" />
        <main>
            <BackgroundView />
            <HomeView class="apply-snap-scroll" ref="home" />
            <AboutView class="apply-snap-scroll" ref="about" />
            <ProjectsView class="apply-snap-scroll" ref="projects" />
            <div class="bg-black">
                <ExperienceView class="apply-snap-scroll" ref="experience" />
                <SkillsView class="apply-snap-scroll" ref="skills" />
            </div>
            <ReviewsView class="apply-snap-scroll" ref="reviews"/>
            <ContactView class="apply-snap-scroll" ref="contact" />
        </main>
        <FooterComp class="apply-snap-scroll" ref="footer" />
    </div>
</template>
<script>
import NavComp from '@/components/NavComp.vue';
import BackgroundView from '@/views/BackgroundView.vue';
import HomeView from '@/views/HomeView.vue';
import AboutView from '@/views/AboutView.vue';
import ProjectsView from '@/views/ProjectsView.vue';
import ExperienceView from '@/views/ExperienceView.vue';
import SkillsView from '@/views/SkillsView.vue';
import ContactView from '@/views/ContactView.vue';
import ReviewsView from '@/views/ReviewsView.vue';
import FooterComp from '@/components/FooterComp.vue';

export default {
    created() {
        window.addEventListener('scroll', this.onScroll);
    },
    data(){
        return {
            windowScrollY: 0
        }
    },
    name: "App",
    async beforeMount(){
        await this.$store.dispatch('getData');
    }, 
    async mounted() {
    },
    components: {
        NavComp,
        ProjectsView,
        BackgroundView,
        AboutView,
        HomeView,
        ExperienceView,
        SkillsView,
        ContactView,
		ReviewsView,
		FooterComp
    },
    methods: {
        onScroll(){
            this.windowScrollY = window.scrollY;
        },
        scroll(){
            window.scrollBy({
              top: 200,
              behavior: 'smooth'
            });
        }
    }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');

#app {
  font-family: "Inter", Helvetica, Arial, sans-serif;
  font-weight: 200;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: black;
}
.snap-scroll {
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
    /* scroll-padding: 40px; */
}
.apply-snap-scroll {
    scroll-snap-align: start;
}
*::-webkit-scrollbar {
	display: none;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
